// frontend/src/services/api.js

import axios from 'axios';

const getBaseUrl = () => {
  const hostname = window.location.hostname;
  return `https://${hostname}`;
};

const api = axios.create({
  baseURL: `${getBaseUrl()}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor to add the Authorization header
api.interceptors.request.use(
  (config) => {
    console.log('Request being sent:', config);
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      
      // Check if the error is due to an expired token
      if (error.response.status === 401) {
        console.log('Token expired, redirecting to login');
        // Clear the token from localStorage
        localStorage.removeItem('token');
        // Redirect to login page
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Separate instance for survey endpoints
export const surveyApi = axios.create({
  baseURL: `${getBaseUrl()}/public`,
  withCredentials: false
});

surveyApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Survey API Error:', error);
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
    }
    return Promise.reject(error);
  }
);

export default api;